import * as go from 'gojs/release/go-module';
import * as React from 'react';

import { changeEntityDrawer } from 'src/store/ui/changeEntityDrawer';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useDiagramObjectClick = () => {
  const { projectId } = useRouterParams();
  const dispatch = useReduxDispatch();

  return React.useCallback<
    NonNullable<go.Diagram['click']> | NonNullable<go.GraphObject['click']>
  >(
    (event, targetObject) => {
      if (!event.shift) {
        const graphObject = targetObject?.part || targetObject;
        dispatch(changeEntityDrawer({ graphObject, projectId }));
      }
    },
    [dispatch, projectId]
  );
};
